var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.actionText,
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-flex",
              { attrs: { md4: "" } },
              [
                _c("v-text-field", {
                  staticClass: "required_field",
                  attrs: {
                    label: _vm.$t("name"),
                    rules: [_vm.fieldIsRequired("Name")]
                  },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "name"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("v-textarea", {
              attrs: { label: _vm.$t("content"), outline: "" },
              model: {
                value: _vm.content,
                callback: function($$v) {
                  _vm.content = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "content"
              }
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28135d38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28135d38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DestinationEdit.vue
// module id = null
// module chunks = 